import { FC, useState, useEffect } from 'react';
import { Modal } from 'jbc-front/components/presenters/ui/Modal';
import Paginator from 'jbc-front/components/Paginator';
import { Table } from '@/components/Table';
import Loading from '@/components/Loading';
import { useQuery } from '@/hooks/graphql/useQuery';
import {
  REPORT_HEALTH_CHECKUP_INSTITUTIONS,
  ReportHealthCheckupInstitutionsQueryVariables,
  ReportHealthCheckupInstitutionsQueryResult
} from './query';
import styles from './MoreHealthCheckupInstitutionsModal.scss';

interface MoreHealthCheckupInstitutionsModalProps {
  reportId: string;
  isOpen: boolean;
  onClose: () => void;
}

export const MoreHealthCheckupInstitutionsModal: FC<MoreHealthCheckupInstitutionsModalProps> = ({
  reportId,
  isOpen,
  onClose
}) => {
  const [page, setPage] = useState(1);
  useEffect(() => setPage(1), [isOpen]);

  const { data, previousData, loading } = useQuery<
    ReportHealthCheckupInstitutionsQueryResult,
    ReportHealthCheckupInstitutionsQueryVariables
  >(REPORT_HEALTH_CHECKUP_INSTITUTIONS, {
    variables: {
      id: reportId,
      page
    },
    fetchPolicy: 'network-only',
    skip: !isOpen
  });

  const totalCount =
    loading && previousData
      ? previousData.client.regularHealthCheckupReport.healthCheckupInstitutions.totalCount
      : data?.client.regularHealthCheckupReport.healthCheckupInstitutions.totalCount;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Header onClose={onClose}>健康診断実施機関</Modal.Header>
      <Modal.Body className={styles.body}>
        {loading ? (
          <div className={styles.loading}>
            <Loading />
          </div>
        ) : (
          <div className={styles.list}>
            <Table className={styles.table}>
              <thead>
                <tr>
                  <th>名称</th>
                  <th>所在地</th>
                </tr>
              </thead>
              {data?.client.regularHealthCheckupReport.healthCheckupInstitutions.list.map(hci => (
                <tr key={hci.id}>
                  <td>{hci.name}</td>
                  <td>{hci.location}</td>
                </tr>
              ))}
            </Table>
          </div>
        )}
        {totalCount ? (
          <div className={styles.paginator}>
            <Paginator
              current={page}
              totalResult={totalCount}
              rowsPerPage={100}
              onClick={(page: number) => setPage(page)}
            />
          </div>
        ) : null}
      </Modal.Body>
    </Modal>
  );
};
